
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, CanLoad, Route, Router, UrlSegment } from "@angular/router";
import isNil from "lodash-es/isNil";
import { Observable, of } from "rxjs";
import { map, filter, timeout, catchError, switchMap, tap } from "rxjs/operators";
import { AuthenticationService } from '../services/authentication.service';
import { StoreRedirectService } from "../services/store-redirect.service";
//vedere il .d.ts. Ignoro perche' vi siano nomi come eu, ebq ecc. Rinominati per chiarezza
import { ɵu as AuthStateService } from "angular-auth-oidc-client";
import { ɵl as CheckAuthService } from "angular-auth-oidc-client";

@Injectable({
  providedIn: 'root',
})
export class OidcGuardService implements CanActivate, CanLoad {

  constructor(private router: Router, private authenticationService: AuthenticationService,
    private storedRedirectService: StoreRedirectService,
    private authStateService: AuthStateService,
    private checkAuthService: CheckAuthService) { }

  canActivate(_activeRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkUser(routerState.url);
  }

  canLoad(_route: Route, segments: UrlSegment[]): Observable<boolean> {
    const routeToRedirect = segments.join('/');
    return this.checkUser(routeToRedirect);
  }

  private checkUser(url: string) {
    const isAuthenticated = this.authStateService.areAuthStorageTokensValid();
    if (isAuthenticated) {
      return this.checkProfile();
    }
    return this.checkAuthService.checkAuth().pipe(
      switchMap((isAuthorized) => {
        if (isAuthorized) {
          return this.checkProfile().pipe(tap((auth) => {
            // const storedRoute = this.storedRedirectService.getStoredRedirectRoute();
            // if (storedRoute) {
            //   this.storedRedirectService.deleteStoredRedirectRoute();
            //   if (auth) {
            //     this.router.navigateByUrl(storedRoute);
            //   }
            // }
            return auth;
          }));
        }
        this.router.navigateByUrl('/nuovoutente'); //se non è autenticato e punta ad area-utente/miei-dati non redinderizza correttamente
        return of(false);
      })
    );
  }

  private checkProfile(): Observable<boolean> {

    return this.authenticationService.userProfile$.pipe(filter(profile => !isNil(profile)),
      timeout(2000),
      catchError((err) => {
        console.error(err);
        this.router.navigate(['/unauthorized']);
        return null;
      }),
      map((profile) => {
        if (profile) {//false se non fa il retrieve
          return true;
        }
        return false;
      }));
  }
}